import isPropValid from '@emotion/is-prop-valid'

/**
 * Helper for styled-components shouldForwardProp. Specify a list of props avoid passing to the underlying component.
 */
export const omitProps =
	(...propNames: Array<string | number>) =>
	(prop: string, target: unknown) =>
		!propNames.includes(prop) && (typeof target !== 'string' || isPropValid(prop))
